import { styled } from '@mui/material/styles'

import { GridWrapper } from '../wrapper'

export const GridHalfScreen = styled(GridWrapper)(() => ({
  flexGrow: 1,
  flexBasis: '50%',
}))
